import { render, staticRenderFns } from "./Tvsvg.vue?vue&type=template&id=6f09d488"
import script from "./Tvsvg.vue?vue&type=script&lang=js"
export * from "./Tvsvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports